import convertTarget from './convertTarget';
import getCtaIcon from './getCtaIcon';

/**
 * @param {CtaLinkApiProps} ctaLink
 * @returns {CtaLinkType}
 */
const getCtaLink = (ctaLink) => {
  /**
   * @type {CtaLinkType}
   */
  const link = {
    href: ctaLink.link.url,
    text: ctaLink.link.text || ctaLink.link.url,
    target: convertTarget(ctaLink.link.target),
    title: ctaLink.link.title || '',
    skin: ctaLink.type,
  };

  if (getCtaIcon(ctaLink.icon)) {
    link.icon = getCtaIcon(ctaLink.icon);
  }

  return link;
};

export default getCtaLink;
